export const state = new Map()

export function initState(props) {
  state.set('locale', props.locale)
  state.set('environment', props.environment)
  state.set('isAbsolutePath', props.isAbsolutePath)
}
